import { createSlice } from "@reduxjs/toolkit";
import {
    createDepartmentService,
getAllDepartmentsService,
getDepartmentByIdService,
updateDepartmentService
} from "../services/departments_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  departmentsList: [],
  metaDepartment: null,
  departmentInfo: null,
  isLoadingAction: false,
};

const slice = createSlice({
  name: "departments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getAllDepartmentsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.departmentsList = action.payload?.data?.data;
        state.metaDepartment = action.payload.data.meta.meta;
      })
      .addCase(getAllDepartmentsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllDepartmentsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getDepartmentByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.departmentInfo = action.payload?.data?.data;
      })
      .addCase(getDepartmentByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getDepartmentByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createDepartmentService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createDepartmentService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createDepartmentService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(updateDepartmentService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(updateDepartmentService.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(updateDepartmentService.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
